import WarningIcon from '@material-ui/icons/Error'
import React from 'react'
import { OpenSolarTheme } from 'Themes'

interface VerificationWarningIconProps {
  fontSize?: string | number
  style?: React.CSSProperties
}

export const VerificationWarningIcon: React.FC<VerificationWarningIconProps> = ({ fontSize = '18px', style = {} }) => {
  return (
    <WarningIcon
      htmlColor={OpenSolarTheme.warningYellow}
      style={{
        fontSize,
        ...style,
      }}
    />
  )
}
